import * as R from "ramda";
import { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import Api from "../../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import { HttpStatus } from "../../../../../common/Constants";
import {
  configMonthToDate,
  configMonthToDateSA,
  monthOptions,
  transformResponseMTD,
  yearOptions,
} from "../config";
import React from "react";
import { saveAs } from "file-saver";
import { buildExcelRequestBodyJualPartMTD } from "../configExcel";

class LaporanMTDPart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: null,
      year: null,
      tableConfig: [],
      tableConfigSA: [],
      dataTable: [],
      dataTableSA: [],
    };
  }

  componentDidMount() {
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      month: monthOptions.find(
        (item) => item.value === currentDate.getMonth() + 1,
      ),
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
    }));
  }

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () => {
    this.fetchData();
  };

  fetchData = async () => {
    try {
      this.props.triggerLoading();

      const res = await fetchDataAsync({
        asyncFn:
          Api.create("NAGAMAS_REPORT_DTO").getLaporanPartEmployeeSalesMTD,
        setError: this.props.setError,
        menuName: "Dashboard Level Mekanik dan SA - Laporan Jual Part MTD",
        args: {
          kodeCabang: [this.props.search.selectedCabang],
          year: this.state.year.value,
          month: this.state.month?.value,
        },
      });

      if (res?.ok && res.data?.data) {
        const rawData = res.data.data;

        const mekanikData = rawData.filter(
          (item) => item.employeeType === "MECHANIC" && item.employeeName,
        );

        const saData = rawData.filter(
          (item) => item.employeeType === "SA" && item.employeeName,
        );

        this.setState({
          dataTable: mekanikData,
          dataTableSA: saData,
          tableConfig: configMonthToDate,
          tableConfigSA: configMonthToDateSA,
        });
      }

      this.props.triggerLoading();
    } catch (err) {
      this.props.triggerLoading();
      console.log(err);
    }
  };

  handlePrint = async () => {
    const { month, year, dataTable, dataTableSA } = this.state;
    this.props.triggerLoading();

    try {
      const reqBody = buildExcelRequestBodyJualPartMTD({
        month,
        year: year.value,
        dataTable,
        dataTableSA,
      });

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
        menuName: "Dashboard Level Mekanik dan SA - Laporan Jual Part MTD",
        setError: this.props.setError,
        args: reqBody,
      });

      if (res?.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, `${reqBody.filename}.xlsx`);
      }
    } catch (error) {
      console.error("Error saat generate Excel:", error);
      this.props.setError("Gagal generate file Excel");
    } finally {
      this.props.triggerLoading();
    }
  };

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            options={monthOptions}
            value={this.state.month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>

        {this.state.dataTable.length > 0 && (
          <div style={{ marginBottom: 30 }}>
            <SimpleDataTable
              key="table-mekanik"
              data={this.state.dataTable}
              columns={this.state.tableConfig}
              options={{
                pagination: false,
                selectableRows: "none",
                selectableRowsHeader: false,
                expandableRows: false,
              }}
            />
          </div>
        )}

        {this.state.dataTableSA.length > 0 && (
          <div style={{ marginBottom: 30 }}>
            <SimpleDataTable
              key="table-sa"
              data={this.state.dataTableSA}
              columns={this.state.tableConfigSA}
              options={{
                pagination: false,
                selectableRows: "none",
                selectableRowsHeader: false,
                expandableRows: false,
              }}
            />
          </div>
        )}

        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton
            id="btn_print"
            text="CETAK"
            onClick={() => this.handlePrint()}
          />
        </FlexView>
      </>
    );
  }
}

export default LaporanMTDPart;
